import { SUBWAY_GEOMETRY_VERSION } from '@vitals/shared';

/**
 * Schema-versioned subway geometry URL (the epoch loader may append `&e=`).
 * The ?v= schema version busts the long HTTP cache on any payload-shape
 * change, so a returning client never pairs new JS with stale cached JSON.
 *
 * Lives outside subwayMap.ts on purpose: that module is pinned byte-for-byte
 * by the tycoon literal-legacy oracle (tests/tycoon-reference), so its own
 * fetchSubwayGeometry keeps an identical inline copy of this template.
 */
export function subwayGeometryUrl(baseUrl = ''): string {
  return `${baseUrl}/api/subway-geometry?v=${SUBWAY_GEOMETRY_VERSION}`;
}
